exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".totals-visualization-view {\n  font-size: 2rem;\n}\n\n.totals-visualization-view .header {\n  padding: 0 2rem;\n  border-bottom: 1px solid #E6E6E6;\n}\n\n.totals-visualization-view .header>div {\n  padding: 2rem;\n}\n\n.totals-visualization-view .header>div:first-child {\n  border-right: 1px solid #E6E6E6;\n}\n\n.totals-visualization-view .header>div small {\n  position: relative;\n  top: -1.2rem;\n}\n\n.totals-visualization-view .header>div b {\n  font-size: 3.5rem;\n}\n\n.totals-visualization-view .visualization {\n  margin: 0 -2rem;\n  border-bottom: 1px solid #E6E6E6;\n}\n\n", ""]);

// exports
